/**
 * Gera um slug consistente a partir de um título
 * Remove acentos, converte para minúsculas e substitui caracteres especiais por hífens
 */
export function generateSlug(title: string): string {
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacríticos (acentos)
    .replace(/[^a-z0-9]+/g, '-') // Remove caracteres especiais e substitui por hífens
    .replace(/(^-|-$)+/g, '') // Remove hífens no início e fim
}
